// composables/useLoading.ts
import { computed, ref } from 'vue'

const pending = ref(0)

export function useLoading() {
  return { isLoading: computed(() => pending.value > 0) }
}

export function loadingStart() {
  pending.value++
}

export function loadingStop() {
  pending.value = Math.max(0, pending.value - 1)
}
